module.exports = __webpack_public_path__ + "img/student_17.6a1f3d43.png";